export const createSeparator = (headers, type, ind, loadId) => {
    const separator = {    
        rowState: {
            type: 'separator',
            id: `${type}_separator_${ind}`,
            loadId,
            visible: true,
            height: 10,
        },
        row: [],
    }

    for (let hederIndex = 0; hederIndex < headers.length; hederIndex++) {
        separator.row.push({
            key: headers[hederIndex].key,
        });
    }

    return separator
};